<app-connect-loader [loading]="(loading | async) && !initialLoadingFinished">
  <div class="container">
    <app-controls-header [viewmodel]="controlsViewmodel"></app-controls-header>
    <app-vakdashboard-table></app-vakdashboard-table>
  </div>
</app-connect-loader>
